import React from 'react'

import { TradeChartContainer } from './styles'
// import TradeChartHeader from './TradeChartHeader'
import TradeChartSection from './TradeChartSection'

const TradeChart = ({ isDragging, split = false }) => {
	return (
		<TradeChartContainer>
			<TradeChartSection isDragging={isDragging} split={split} />
		</TradeChartContainer>
	)
}

export default React.memo(TradeChart)
